import { updateEditorCanvas } from '~graphql/controllers';

export const deleteEditorPage = async (canvasId, pageId) => {
  const data = {
    editor_canvas_pages: {
      remove: [pageId],
    },
  };

  await updateEditorCanvas(canvasId, data);
};
